import { useState, useEffect } from 'react'
import {
    Fab,
    TextareaAutosize,
    Grid,
    Button,
    Dialog,
    Input

} from '@mui/material'
import { Close } from '@mui/icons-material'
import { useAuth, useAlertContext } from '../context'
import { useStatus } from '../context/Status.context'
import { GenerationStatusModal } from './StatusModal'

const ReportCommitDialog = ({ open, report, closeModal, isTermJornada, terminarjornada, messageType }) => {
    const { userData } = useAuth()
    const { setstatus } = useStatus()
    const { setAlertSimple } = useAlertContext()
    const [message, setMessage] = useState('')
    const [operadores, setOperadores] = useState(0)
    const [level, setLevel] = useState(0)

    const sendMessage = () => {
        if ((isTermJornada || level < 1) && (!operadores || Number(operadores) <= 0)) {
            setAlertSimple('Advertencia', 'Debe ingresar un número de operadores válido.')
            return
        }

        if (message.length > 1) {
            setstatus({
                status: 'generating',
                message: isTermJornada ? 'Terminando jornada...' : 'Enviando Orden de Trabajo...',
                isSummary: false
            })
            const data = {
                comentario: message,
                operarios: Number(operadores)
            }
            console.log('[ReportCommitDialog] Sending data:', data)

            if (isTermJornada) {
                terminarjornada(data)
            } else {
                closeModal(data)
            }
        } else {
            setAlertSimple('Comentario Requerido', 'Por favor deje un comentario a la actividad.')
        }
    }

    useEffect(() => {
        if (report) {
            if (report.level !== undefined) {
                setLevel(report.level)
            }
        }
    }, [report])

    const removeMessage = () => {
        setMessage('')
    }

    const closeModalActivate = () => {
        closeModal(false)
    }

    const getTitle = () => {
        let otIdentifier = ''
        if (report && (report.newIdIndex || report.idIndex)) {
            otIdentifier = `OT: ${report.newIdIndex || report.idIndex} - `
        }

        if (isTermJornada) return `${otIdentifier}Terminar Jornada.`
        if (level === 0) return `${otIdentifier}Enviar OT a revisión.`
        if (level === 1 || level === 2) return `${otIdentifier}Aprobar y elevar reporte.`
        if (level === 3) return `${otIdentifier}Aprobar y finalizar OT`
        return `${otIdentifier}Enviar comentario.`
    }

    return (
        <Dialog
            open={open}
            onClose={closeModalActivate}
        >
            <div style={{ padding: 30, width: 600 }}>
                <Grid>
                    <h3>{getTitle()}</h3>
                </Grid>
                <Grid container style={{ padding: 10 }}>
                    <div style={{ width: '100%', marginBottom: 30, marginTop: 30 }}>
                        <TextareaAutosize
                            aria-label="empty textarea"
                            placeholder="Deje su comentario"
                            minRows={10}
                            maxRows={15}
                            style={{ width: '100%', fontSize: 18, fontFamily: 'Arial, Helvetica, sans-serif', marginBottom: 30 }}
                            value={message}
                            onChange={(e) => { setMessage(e.target.value) }}
                        />
                        {(level < 1) && <Grid item>
                            <p style={{ fontSize: 10, color: '#636363' }}>Cantidad total de mantenedores</p>
                            <Input
                                value={operadores}
                                onChange={(e) => setOperadores(e.target.value)}
                                type={'number'}
                                placeholder='Cantidad total de mantenedores'
                            />
                        </Grid>}
                    </div>
                    <Button variant="contained" color={'primary'} style={{ borderRadius: 50 }} onClick={() => { sendMessage() }}>
                        Enviar Mensaje
                    </Button>
                </Grid>
                <Fab onClick={() => closeModalActivate()} style={{ position: 'absolute', right: 10, top: 10, boxShadow: 'none', backgroundColor: 'transparent' }}>
                    <Close style={{ color: '#ccc' }} />
                </Fab>
                <GenerationStatusModal />
            </div>
        </Dialog>
    )
}

export default ReportCommitDialog
